module.exports = __webpack_public_path__ + "static/media/cq_ricevi_messaggio b.ff3d486d.svg";